module.exports = __webpack_public_path__ + "static/media/ETH-AVAX.920168e9.png";